/* eslint-disable no-dupe-keys */
import React, { useEffect } from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fab,
} from '@mui/material';

import classNames from 'classnames';
import { makeStyles } from 'tss-react/mui';

export const PreviewWrapper: React.FC = ({ children }: any) => {
  const [isOpen, setOpen] = React.useState(false);

  return (
    <div style={{ width: '100%', height: '100%', paddingTop: 20 }}>
      <Fab
        type="submit"
        variant="extended"
        size="medium"
        color="primary"
        onClick={() => setOpen(true)}
      >
        Show GiftCard preview
      </Fab>
      <Dialog
        fullWidth
        maxWidth="md"
        onClose={() => setOpen(false)}
        open={isOpen}
      >
        <DialogTitle>Preview of your GiftCard</DialogTitle>
        <DialogContent>
          {children}
          <DialogActions>
            <Button
              color="primary"
              variant="contained"
              onClick={() => setOpen(false)}
            >
              Close
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </div>
  );
};

const useStyles = makeStyles()(() => ({
  preview: {
    background: 'linear-gradient(to bottom,  #e8e8ea 0%,#efefef 100%)',
    transition: 'all .5s ease',
    'backface-visibility': 'hidden',
    /* transform: "perspective(800px) rotateY(-5deg)", */
  },
  hoverEffect: {
    borderRadius: '2px',
    borderLeft: '2px solid #f5f5f7',
    borderBottom: '2px solid #f5f5f7',
    borderRight: '1px solid #adc0bc',
    boxShadow: '3px 0px 13px 0px #333',
    borderTop: '1px solid #f4f4f6',
    '&:hover': {
      transform: 'scale(1.2)',
    },
  },
}));

interface EcardsPreviewProps {
  disableHoverEffect: boolean;
  templateUrl: string;
  amount: number;
  senderName: string;
  recipientName: string;
  message: string;
  coverImageUrl: string;
}
const EcardsPreview: React.FC<EcardsPreviewProps> = ({
  disableHoverEffect,
  templateUrl,
  amount,
  senderName,
  recipientName,
  message,
  coverImageUrl,
}) => {
  const { classes } = useStyles();
  const previewRef = React.useRef<HTMLIFrameElement>(null);

  const renderEcard = async (htmlResponse: string) => {
    if (!previewRef.current) return;

    const filledDesignHtml = htmlResponse
      .replaceAll('{sender_name}', senderName)
      .replaceAll('{recipient_name}', recipientName)
      .replaceAll('{amount}', amount.toString())
      .replaceAll('{code}', '1234-5678-9876-5432')
      .replaceAll(
        'html {',
        `html { transform: scale(${
          previewRef.current.clientWidth / 1024
        }); transform-origin: 0 0; pointer-events: none;`,
      )
      .replaceAll('{cover_image}', coverImageUrl)
      .replaceAll('{message}', message.replace('\n', '<br/>'));

    const doc = previewRef.current.contentWindow.document;
    doc.write(filledDesignHtml);
    doc.close();
  };

  useEffect(() => {
    const getHtmlResponse = async () => {
      const response = await fetch(templateUrl);
      const htmlResponse = await response.text();
      await renderEcard(htmlResponse);
    };

    getHtmlResponse();
  }, [amount, coverImageUrl, message, recipientName, senderName, templateUrl]);

  return (
    <iframe
      title="ECard Preview"
      ref={previewRef}
      className={classNames(classes.preview, {
        [classes.hoverEffect]: !disableHoverEffect,
      })}
      height={
        previewRef?.current && (297 / 212) * previewRef.current.clientWidth
      }
      width="100%"
    />
  );
};

export default EcardsPreview;
